import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Select, SelectProps } from "@mantine/core";

import { DeliveryState } from "../../hooks/campaigns";

export interface SelectDeliveryTypeProps extends Omit<SelectProps, "data"> {
    label?: string;
    placeholder?: string;
}

export const SelectDeliveryType = ({ label, placeholder, ...rest }: SelectDeliveryTypeProps) => {
    const { t, i18n } = useTranslation(["common"]);

    const data = useMemo(() => {
        return Object.values(DeliveryState).map((value) => ({
            value: value,
            label: t(`campaign_delivery_type_${value}`),
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <Select
            {...rest}
            label={label !== undefined ? label : t("campaign_delivery_type")}
            placeholder={placeholder !== undefined ? placeholder : t("campaign_delivery_type")}
            data={data}
        />
    );
};
